import { openBlock as s, createElementBlock as l, renderSlot as u, resolveComponent as r, normalizeStyle as t, createElementVNode as n, createVNode as c } from "vue";
import { _ as d } from "./_plugin-vue_export-helper-dad06003.js";
import { C as f } from "./PreloaderIcon-b44be854.js";
import { C as g } from "./ChevronLeftIcon-b6affe9b.js";
const _ = {}, m = {
  type: "button",
  class: "ct-btn-3 ct-btn-icon-xs"
};
function h(e, a) {
  return s(), l("button", m, [
    u(e.$slots, "default")
  ]);
}
const L = /* @__PURE__ */ d(_, [["render", h]]), v = {
  components: {
    ChevronLeftIcon: g,
    ChevronRightIcon: f
  },
  props: {
    colors: {
      type: Object,
      default: () => ({})
    }
  }
};
function p(e, a, o, y, C, x) {
  const i = r("ChevronLeftIcon"), b = r("ChevronRightIcon");
  return s(), l("div", {
    class: "inline-flex justify-start items-center rounded-lg border ct-border-1 shadow-sm",
    style: t({
      "border-color": o.colors.border
    })
  }, [
    n("button", {
      type: "button",
      class: "slider-arrow-left p-2.5 rounded-l-lg ct-bg-1 hover:ct-bg-1 ct-fg-3 hover:ct-fg-2 border-r ct-border-1 disabled:ct-fg-disabled disabled:pointer-events-none transition-all duration-300 ease-in-out",
      style: t({
        "border-color": o.colors.border,
        "background-color": o.colors.background,
        color: o.colors.text
      })
    }, [
      c(i)
    ], 4),
    n("button", {
      type: "button",
      class: "slider-arrow-right p-2.5 rounded-r-lg ct-bg-1 hover:ct-bg-1 ct-fg-3 hover:ct-fg-2 disabled:ct-fg-disabled disabled:pointer-events-none transition-all duration-300 ease-in-out",
      style: t({
        "border-color": o.colors.border,
        "background-color": o.colors.background,
        color: o.colors.text
      })
    }, [
      c(b)
    ], 4)
  ], 4);
}
const R = /* @__PURE__ */ d(v, [["render", p]]);
export {
  R as B,
  L as a
};
